// Maps the current URL to its counterpart in the other language so the header
// language switcher can keep the visitor on the same page instead of dumping
// them on a language home page.
import { ES_ALL_PAGES } from "@/lib/es-pages";

const EN_STORY_PREFIX = "/results/story/";
const ES_STORY_PREFIX = "/es/antes-y-despues/historia/";

export interface LanguageSwitchTarget {
  /** Path of the counterpart page. */
  href: string;
  /** Language of the counterpart page. */
  lang: "en" | "es";
  /** Link label, written in the target language. */
  label: string;
  /** True when the exact page exists in the target language. */
  exact: boolean;
}

function normalize(pathname: string) {
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}

export function isSpanishPath(pathname: string) {
  const path = normalize(pathname);
  return path === "/es" || path.startsWith("/es/");
}

/** Counterpart page for the given path, preserving the page whenever possible. */
export function languageSwitchTarget(pathname: string): LanguageSwitchTarget {
  const path = normalize(pathname);

  if (isSpanishPath(path)) {
    if (path.startsWith(ES_STORY_PREFIX)) {
      return {
        href: `${EN_STORY_PREFIX}${path.slice(ES_STORY_PREFIX.length)}`,
        lang: "en",
        label: "English",
        exact: true,
      };
    }
    const page = ES_ALL_PAGES.find((p) => p.es === path);
    return {
      href: page ? page.en : "/",
      lang: "en",
      label: "English",
      exact: Boolean(page),
    };
  }

  if (path.startsWith(EN_STORY_PREFIX)) {
    return {
      href: `${ES_STORY_PREFIX}${path.slice(EN_STORY_PREFIX.length)}`,
      lang: "es",
      label: "Español",
      exact: true,
    };
  }

  const page = ES_ALL_PAGES.find((p) => p.en === path && !p.noAlternate);
  return {
    href: page ? page.es : "/es",
    lang: "es",
    label: "Español",
    exact: Boolean(page),
  };
}
